<div mat-dialog-content>

  <div class="modal-header" style="border-bottom: none;">
    <h5 class="modal-title">Tópicos</h5>
    <button mat-stroked-button
          [disabled]="topics.length !== 0" 
          [title]="topics.length !== 0 ? 'Botão disponível apenas quando não há tópicos' : 'Clique para adicionar a estrutura base'"
          (click)="addBasicStructure()">
      Adicionar Estrutura Base
    </button>
  </div>
  
  <div class="modal-body" style="border-bottom: none;">
    <mat-radio-group (change)="getSelectedOption($event.value)">
      <mat-radio-button
        *ngFor="let topic of topics"
        [checked]="isFirstTopic(topic.literatureRevisionStruct.id)"
        [value]="{
          tema: topic.literatureRevisionStruct.tema,
          id: topic.literatureRevisionStruct.id
        }"
      >
        {{ topic.literatureRevisionStruct.tema }}
      </mat-radio-button>
    </mat-radio-group>
  
    <div>
      <form class="d-flex my-2 hide-form" #formRepo>
        <input
          #topicName
          name="topicName"
          class="form-control ml-3 col-8"
          type="text"
          placeholder="Nome do tópico"
          aria-label="Nome do tópico"
        />
        <button
        class="btn btn-invite-add-repo col-4"
        type="button"
        (click)="saveTopic(topicName.value)"
        >
          <i class="fas fa-plus"></i> Adicionar tópicos
        </button>
      </form>
      
    </div>
    <div class="text-editor-div" [hidden]="showTextEditor" >
      <ckeditor
        class="text-editor"
        #textEditor
        debounce="500"
        [config]="editorConfig"
      >
        <ckbutton
          [name]="'pasteFromWordButton'"
          [command]="'pasteFromWordCmd'"
          [label]="'Colar sem formatação'"
        >
          texto
        </ckbutton>
      </ckeditor>
      <button
        mat-raised-button
        type="button"
        class="btn btn-primary mainBackground-color text-editor-button"
        (click)="editText()"
      >
        Salvar e fechar
      </button>
    </div>
  </div>
  
  <div class="modal-footer" style="border-bottom: none;">
    <button
      mat-raised-button
      type="button"
      class="btn btn-link mainFontColor"
      (click)="dialogRef.close()"
    >
      Voltar
    </button>
    <button
      mat-raised-button
      type="button"
      class="btn btn-primary mainBackground-color"
      (click)="exportDocx()"
    >
      Exportar conteúdo
    </button>
    <button
      mat-raised-button
      type="button"
      class="btn btn-primary mainBackground-color"
      (click)="deleteTopic()"
    >
      Excluir
    </button>
    <button
      mat-raised-button
      type="button"
      class="btn btn-primary mainBackground-color"
      (click)="showTextEditorFn()"
    >
      Editar
    </button>
    <button
      mat-raised-button
      type="button"
      class="btn btn-primary mainBackground-color"
      (click)="saveText()"
    >
      Salvar
    </button>
  </div>
</div>
